<script>
  import {fly} from 'svelte/transition'
  import { parc } from "../store/ImmoStore";
  import LoyersTableau from "../components/LoyersTableau.svelte";

  //import { coffre } from "../store/OpvcmStore";
  import CardPrix from "../components/ihm/CardPrix.svelte";

  /**
   *
   * @param data
   */
  const nbreApptTotal = (data) => {
    if ($parc != undefined) {
      return Object.keys(data).length;
    }
    return 0;
  };

  /**
   *
   * @param data
   */
  const nbreApptVendus = (data) => {
    let tot = 0;
    if ($parc != undefined) {
      $parc.forEach((element) => {
        if (element.IM_VENDU == 1) {
          tot += 1;
        }
      });
    }
    return tot;
  };

  /**
   *
   * @param data
   */
  const nbreApptType = (data) => {
    let tot = { prop: 0, indi: 0, princ: 0, nue: 0 };
    if ($parc != undefined) {
      $parc.forEach((element) => {
        switch (element.IM_TYPE_PROP) {
          case "PROP":
            tot["prop"] += 1;
            break;
          case "PRINC":
            tot["princ"] += 1;
            break;
          case "NUE":
            tot["nue"] += 1;
            break;
          case "INDI":
            tot["indi"] += 1;
            break;
        }
      });
    }
    //console.debug("Type = " + JSON.stringify(tot));
    return tot;
  };
</script>

<!-- compteurs -->

<div class="container-fluid"
    in:fly="{{ y: -50, duration: 250, delay: 300 }}"
    out:fly="{{ y: -50, duration: 250 }}" >
  {#await $parc then}
    <div class="row">
      <div class="card col-6">
        <CardPrix
          cardTitle="Total parc"
          cardPrix={new Intl.NumberFormat("fr-FR").format(nbreApptTotal($parc))}
          cardColor="orange"
        />
      </div>
      <div class="card col-6">
        <CardPrix
          cardTitle="Nbre vendus"
          cardPrix={new Intl.NumberFormat("fr-FR").format(
            nbreApptVendus($parc)
          )}
          cardColor="orange"
        />
      </div>
    </div>
    <!-- decompte par type appt -->
    <div class="row">
      {#each Object.entries(nbreApptType($parc)) as [key, vals]}
        <div class="col-6">
          <CardPrix
            cardTitle={key}
            cardPrix={new Intl.NumberFormat("fr-FR").format(vals)}
            cardColor="green"
          />
        </div>
      {/each}
    </div>

    <!--  Loyer -->

    <LoyersTableau />
  {/await}
</div>

<style>
  .card {
    text-align: center;
    margin-top: 3px;
  }
</style>
